<template>
  <div class="transportation-ticket-card">
    <div class="transportation-ticket-card__header d-flex justify-content-between">
      <div class="transportation-ticket-card__header__first-text">{{ $t(ticketTitle) }}</div>
      <div class="transportation-ticket-card__header__second-text" @click="goBack($event, routeString)">{{ $t('change_ticket') }}</div>
    </div>
    <div class="transportation-ticket-card__content d-flex flex-column justify-content-center">
      <div class="transportation-ticket-card__content__travel-where">
        {{ transportation.pickup_city.address_to_show }} - {{ transportation.dropoff_city.address_to_show }}
      </div>
      <div class="transportation-ticket-card__content__date">
        {{ dateHelpers.dateToDisplay(tripDate) }}
      </div>
    </div>
    <div class="transportation-ticket-card__line">
    </div>
    <div class="transportation-ticket-card__footer d-flex justify-content-between">
      <div class="transportation-ticket-card__footer__time">{{ transportation.pickup_time }} - {{ transportation.drop_off_time }}</div>
      <div class="transportation-ticket-card__footer__cost">{{ transportation.totals.tax_total }} {{$t('symbol_eur')}}</div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";
import type {IApiResponseTransportation} from "../../interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";
import {dateHelpers} from "../../helpers/dateHelpers";

export default defineComponent({
  name: 'TransportationTicketCardComponent',
  computed: {
    dateHelpers() {
      return dateHelpers
    }
  },

  props: {
    transportation: {
      type: Object as PropType<IApiResponseTransportation>,
      required: true
    },
    tripDate: {
      type: Date
    },
    ticketTitle: {
      type: String,
      required: true
    },
    routeString: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      testState: null
    }
  },

  methods: {
    goBack($event, route) {
      this.$router.push(route);
    }
  }
})
</script>

<style scoped lang="scss">
@import './transportationTicketCard.scss';
</style>